import AccountChangePasswordForm from "app/features/authentication/templates/AccountChangePasswordForm";
import { useLocalSearchParams } from "expo-router";

export default function AccountResetScreen() {
  const { email, token } = useLocalSearchParams();

  return (
    <AccountChangePasswordForm
      type="reset"
      email={email as string}
      token={token as string}
    />
  );
}
